(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('PsychCountDialogController', PsychCountDialogController);

    PsychCountDialogController.$inject = ['$uibModalInstance', 'count'];

    function PsychCountDialogController($uibModalInstance, count) {
        var vm = this;
        vm.count = count;

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.yes = function() {
            $uibModalInstance.close(true);
        };
    }
})();
